import React, { memo } from "react";
import { validators, formats } from "investira.sdk";
import {
  Stack,
  Divider,
  TabContext,
  TabList,
  Box,
  Tab,
  TabPanel,
  Skeleton,
  Alert,
} from "investira.react.components";
import { DataProcessAnimation } from "../../../components/molecules";
// import Highlights from "./Highlights";
// import SegmentosAplicacao from "./SegmentosAplicacao";

const ConsultaEnquadramento = memo((props) => {
  return (
    <Stack flexGrow={1} justifyContent="center" alignItems="center">
      <DataProcessAnimation />
    </Stack>
  );
  // return (
  //   <Stack spacing={2}>
  //     <Stack
  //       direction="row"
  //       gap={1.5}
  //       alignItems="center"
  //       sx={{
  //         flex: 1,
  //         minWidth: 0,
  //       }}
  //     >
  //       <Skeleton variant="rounded" width={16} height={16} />
  //       <Skeleton variant="rounded" width={100} height={16} />
  //       <Divider orientation="vertical" flexItem />
  //       <Skeleton variant="rounded" width={200} height={16} />
  //     </Stack>
  //     <Divider />
  //     {/* OVERVIEW */}
  //     <Alert severity="warning">Aguarde. Processando...</Alert>
  //     <Stack
  //       direction={{ xs: "column", md: "row" }}
  //       sx={{ gap: 2 }}
  //       component="section"
  //     >
  //       <Stack
  //         sx={{
  //           flex: 1,
  //           minWidth: 0,
  //           gap: 1,
  //         }}
  //       >
  //         <Skeleton variant="rounded" height={200} />
  //       </Stack>
  //       <Stack
  //         sx={{
  //           flex: 1,
  //           minWidth: 0,
  //           gap: 1,
  //         }}
  //       >
  //         <Skeleton variant="rounded" height={200} />
  //       </Stack>
  //       <Stack
  //         sx={{
  //           flex: 1,
  //           minWidth: 0,
  //           gap: 1,
  //         }}
  //       >
  //         <Skeleton variant="rounded" height={200} />
  //       </Stack>
  //       <Stack
  //         sx={{
  //           flex: 1,
  //           minWidth: 0,
  //           gap: 1,
  //         }}
  //       >
  //         <Skeleton variant="rounded" height={200} />
  //       </Stack>
  //     </Stack>
  //     <Stack
  //       direction="row"
  //       gap={1.5}
  //       alignItems="center"
  //       sx={{
  //         flex: 1,
  //         minWidth: 0,
  //       }}
  //     >
  //       <Skeleton variant="rounded" width={100} height={44} />
  //       <Skeleton variant="rounded" width={100} height={44} />
  //       <Skeleton variant="rounded" width={100} height={44} />
  //     </Stack>
  //     <Stack>
  //       <Stack
  //         direction={{ xs: "column", md: "row" }}
  //         sx={{ gap: 2 }}
  //         component="section"
  //       >
  //         <Stack
  //           sx={{
  //             flex: 1,
  //             minWidth: 0,
  //             gap: 1,
  //           }}
  //         >
  //           <Skeleton variant="rounded" height={200} />
  //         </Stack>
  //         <Stack
  //           sx={{
  //             flex: 1,
  //             minWidth: 0,
  //             gap: 1,
  //           }}
  //         >
  //           <Skeleton variant="rounded" height={200} />
  //         </Stack>
  //         <Stack
  //           sx={{
  //             flex: 1,
  //             minWidth: 0,
  //             gap: 1,
  //           }}
  //         >
  //           <Skeleton variant="rounded" height={200} />
  //         </Stack>
  //         <Stack
  //           sx={{
  //             flex: 1,
  //             minWidth: 0,
  //             gap: 1,
  //           }}
  //         >
  //           <Skeleton variant="rounded" height={200} />
  //         </Stack>
  //       </Stack>
  //       <Stack
  //         direction={{ xs: "column", md: "row" }}
  //         sx={{ gap: 4 }}
  //         component="section"
  //         alignItems="center"
  //       >
  //         <Stack
  //           sx={{
  //             flex: 2,
  //             minWidth: 0,
  //             gap: 1,
  //           }}
  //         >
  //           <Stack direction={{ xs: "column", md: "row" }} py={1}>
  //             <Stack
  //               sx={{
  //                 flex: 1,
  //                 minWidth: 0,
  //               }}
  //             >
  //               <Skeleton variant="rounded" height={350} />
  //             </Stack>
  //           </Stack>
  //         </Stack>
  //         <Stack
  //           sx={{
  //             flex: 3,
  //             minWidth: 0,
  //             gap: 1,
  //             py: 2,
  //           }}
  //         >
  //           <Skeleton variant="rounded" height={350} />
  //         </Stack>
  //       </Stack>
  //       <Skeleton variant="rounded" height={500} />
  //     </Stack>
  //   </Stack>
  // );
});

export default ConsultaEnquadramento;
